import React from "react";
import FacetContainer from "../customFacet";
const MobileFilterMenu = () => {
  return (
    <div className="mobile-filters">
      {/* Filter menu open button */}
      <div className="filter-bar__combined-menu" id="filter-bar__combined-menu">
        <a className="filter-bar__combined-menu__a erase-trace" href="#filter-bar__menu">
          <span className="filter-bar__text-label-mobile">Filters</span>
          <span className="filter-bar__filter-icon"></span>
        </a>
      </div>
      {/* Mobile filter drawer */}
      <div className="filter-bar__menu filter-bar__menu--job" id="filter-bar__menu">
        <div className="filter-bar__header-mobile">
          <span className="filter-bar__header-mobile__text">Filters</span>
          <a
            className="filter-bar__header-mobile__close-icon erase-trace"
            href="#filter-bar__content"
            aria-label="close"
          ></a>
        </div>
        <FacetContainer field={"global_filter_category.enum"} label={"Role"} />
        <FacetContainer field={"placement_types.enum"} label={"Placement Types"} />
        <FacetContainer field={"markets.enum"} label={"Location"} />
        <FacetContainer field={"offsite_preference_name.enum"} label={"Location Preference"} />
      </div>
      {/* Mobile footer buttons */}
      <div className="filter-bar__dropdown-buttons-mobile">
        <a className="tertiary-info erase-trace" href="/find-work">Clear all</a>
        <div className="wp-block-button is-style-dark-orange">
          <button
            className="wp-block-button__link"
            onClick={() => window.location.replace("#filter-bar__content")}
          >
            Show Results
          </button>
        </div>
      </div>
    </div>
  );
};
export default MobileFilterMenu;
